import React,{useEffect,Fragment} from 'react';
// import io from 'socket.io-client';
import axios from "axios";
import client from '@/lib/feathers';
import styles from './index.module.scss';
// style={{backgroundColor:bgColor}}
const BAButton = (props)=> {
 
  let color = 'gray';
  if((props.item && props.item.value==='開啟')||(props.item && typeof props.item.value=== 'number'&&props.item.value>0))
    color='green';
  useEffect(()=>{
    // socket = io('http://localhost:3030/');
    // socket.on('hello',data=>{
    //   console.log('==hello',data)
    //   socket.emit('msg','message','test')
    // })
    // client.reAuthenticate().then((data) => {
    //   console.log('==mbb relogin ok', data.user.email);
    // }).catch(err => {
    //   console.log('==mbb relogin fail');
    //   // history.push('/user/login');
    // })
  },[])
  function getTextUI(item){
    if(item&&item.text){
      const arr=item.text.split('\n').map(x=><div>{x}</div>)// .join(<br />)
      return arr
    }else{
      return <Fragment>無文字</Fragment>
    }
  }
  return (
    <div
      className={styles.BAButton}
      style={{backgroundColor:color}}
      onClick={()=>{
        console.log("props.item",props.item)
        const value = (props.item.value=='關閉' )?'開啟':'關閉'
        let newObj = {...props.item,value:value}
        console.log("obj",newObj)
        axios('/ezcon/api/ba/frontSetstate', {
          method: 'POST',
          headers: { authorization: window.localStorage['feathers-jwt'] },
          data : newObj
        }).then((res) => {
          console.log('==Setstate OK',res);
        }).catch(error => {
          console.error('==Setstate Error', error);
        })
          //  client.io.emit('ba_cmd',{name:props.item.name,value:value})
        // alert(props.item.name)
        // client.io.emit('ba_cmd',{裝置名稱:props.item.裝置名稱,狀態:value})
        // alert(props.item.裝置名稱)
      }}
    >
      <div className={styles.ItemText}>
        {getTextUI(props.item)}
      </div>
    </div>
  );
}

export default BAButton;
